export const CUSTOM_EVENTS = {
    TRIGGER_METHOD: 'trigger-method'
};
